import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

const Label = ({ text, hint, className, weight }) => (
  <StyledLabel className={className} weight={weight}>
    {text}
    {hint && (
      <>
        <span>&nbsp;-</span>
        <span className="hint">{hint}</span>
      </>
    )}
  </StyledLabel>
)

Label.defaultProps = {
  weight: 'normal',
}

Label.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  hint: PropTypes.string,
  weight: PropTypes.oneOf(['bold', 'normal']),
}

export default Label

const StyledLabel = styled.label(
  (props) => `
    font-weight: ${props.weight};
  `
)
